export const memoizedCookies: Map<string, string> = new Map<string, string>();
